import { z } from 'zod';
// User pastes only their 12-digit AWS account id. The role ARN is derived
// from a deterministic stack/role name; the bucket is discovered by tag.
export const ConnectBucketRequest = z.object({
    accountId: z.string().regex(/^\d{12}$/, 'AWS Account ID deve essere 12 cifre'),
});
export const BucketStatusResponse = z.object({
    connected: z.boolean(),
    roleArn: z.string().optional(),
    bucketName: z.string().optional(),
    region: z.string().optional(),
    accountId: z.string().optional(),
});
// What the assisted-onboarding screen needs: ExternalId to embed in the
// launch URL, our app's account id (so the user can sanity-check the trust
// policy), a suggested bucket name, and a ready-to-click launch URL.
export const OnboardingTemplateResponse = z.object({
    externalId: z.string(),
    appAwsAccountId: z.string(),
    suggestedBucketName: z.string(),
    stackName: z.string(),
    templateUrl: z.string().url(),
    launchUrl: z.string().url(),
});
// Wipe is destructive: the body must contain a literal sentinel so a
// fat-fingered DELETE never trashes the user's data. The string is fixed
// (not localised) — the UI also enforces it.
export const BucketWipeRequest = z.object({
    confirm: z.literal('WIPE'),
});
export const BucketWipeResponse = z.object({
    wiped: z.boolean(),
    deletedObjects: z.number().int().nonnegative(),
    deletedAlbums: z.number().int().nonnegative(),
    deletedPhotos: z.number().int().nonnegative(),
    abortedUploads: z.number().int().nonnegative(),
});
//# sourceMappingURL=bucket.js.map